import React from 'react';
import { useListingPageContext } from '../context/ListingPageContext';
import SectionAgencyHero from './SectionAgencyHero/SectionAgencyHero';

import css from '../ListingPage.module.css';

function RenderAgency() {
  const { isMobileLayout, intl, viewport } = useListingPageContext();
  return (
    <div className={css.pageRoot}>
      <SectionAgencyHero isMobileLayout={isMobileLayout} intl={intl} viewport={viewport} />
    </div>
  );
}

export default RenderAgency;
